import ApplicationController from './application_controller'
/* This is the custom StimulusReflex controller for the EosCategory Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = [
    'formTemplate',
    'funds',
    'fundsList',
    'searchForm',
    'searchFormWrapper',
    'searchField',
    'client',
    'main',
    'noFunds'
  ]

  static values = {
    id: Number
  }

  // events
  // connect() {
  //   // this.resetFirstAndLastClasses()
  //   // this.focusSearchField()
  //   // this.resetSearchForm()
  //   // this.disableClientIfMain()
  // }

  sort(event) {
    let element = document.querySelector("#eos-category-root")
    let fund_elements = document.getElementsByClassName('eos-category-item')
    let funds = Array.from(fund_elements).map((fund, index) => {
      const previousPosition = parseInt(fund.dataset.eosCategoryPosition)
      const position = index + 1

      this.updateFundPosition(fund, position)
      this.showPositionChange(fund, previousPosition, position)
      fund.dataset.eosCategoryPosition = position

      return {
        id: fund.dataset.eosCategoryFundId,
        position: position,
        fund_id: fund.dataset.eosCategoryFund
      }
    })
    element.dataset.funds = JSON.stringify(funds)
    this.stimulate('EosCategoryReflex#sort', element, { serializeForm: true })
  }

  add(event) {
    let fundId = event.target.dataset.fundId
    let eosCategoryId = this.idValue

    if (this.fundInList(fundId)) {
      return false
    }

    this.stimulate('EosCategoryReflex#add', fundId, eosCategoryId)
  }

  remove(event) {
    event.preventDefault()
    let eosCategoryId = this.idValue
    let fundId = event.target.dataset.fundId

    this.stimulate('EosCategoryReflex#remove', fundId, eosCategoryId)
  }

  updateEosCategory(event) {
    event.preventDefault()
    let eosCategoryId = event.target.value

    this.stimulate('EosCategoryReflex#remove', fundId, eosCategoryId)
  }

  nextPosition() {
    return this.fundsTarget.querySelectorAll('[data-fund]').length
  }

  fundInList(fundId) {
    return this.fundsIds().includes(parseInt(fundId))
  }

  fundsIds() {
    return Array.prototype.map.call(
      this.fundsTarget.querySelectorAll('[data-fund]'),
      function (item) {
        return parseInt(item.dataset.fund)
      }
    )
  }

  moveHigher(fund) {
    var actualPosition = parseInt(fund.querySelector('.fund-position').value)
    fund.querySelector('[data-position]').innerHTML = actualPosition - 1
    fund.querySelector('.fund-position').value = actualPosition - 1
  }

  updateFundPosition(fund, position) {
    const positionLabel = fund.querySelector('[data-position]')
    const positionField = fund.querySelector('.fund-position')

    if (positionLabel) {
      positionLabel.innerHTML = `${position} - `
    }

    if (positionField) {
      positionField.value = position
    }
  }

  showPositionChange(fund, previousPosition, newPosition) {
    if (Number.isNaN(previousPosition) || previousPosition === newPosition) {
      this.clearPositionChange(fund)
      return
    }

    const delta = previousPosition - newPosition
    const direction = delta > 0 ? 'up' : 'down'
    const movedBy = Math.abs(delta)
    const fundCard = fund.querySelector('.eos-category-fund')
    const title = fund.querySelector('[data-name]')?.parentElement

    this.clearPositionChange(fund)

    if (!fundCard || !title) {
      return
    }

    fundCard.classList.add(`eos-category-fund--moved-${direction}`)

    const badge = document.createElement('span')
    badge.className = `badge ml-2 eos-category-rank-badge eos-category-rank-badge--${direction}`
    badge.textContent = `${delta > 0 ? '+' : '-'}${movedBy}`
    title.appendChild(badge)

    fund.positionChangeTimeout = window.setTimeout(() => {
      this.clearPositionChange(fund)
    }, 1000)
  }

  clearPositionChange(fund) {
    const fundCard = fund.querySelector('.eos-category-fund')
    const badge = fund.querySelector('.eos-category-rank-badge')

    if (fund.positionChangeTimeout) {
      window.clearTimeout(fund.positionChangeTimeout)
      fund.positionChangeTimeout = null
    }

    if (fundCard) {
      fundCard.classList.remove('eos-category-fund--moved-up', 'eos-category-fund--moved-down')
    }

    if (badge) {
      badge.remove()
    }
  }

  hideNoFund() {
    this.noFundsTarget.classList.add('d-none')
  }

  getNextSibling(elem, selector) {
    var sibling = elem.nextElementSibling
    if (!selector) return sibling
    while (sibling) {
      if (sibling.matches(selector)) return sibling
      sibling = sibling.nextElementSibling
    }
  }
}
